export default "__VITE_ASSET__j152$r96__"